module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "cb-section cb-bar"
  }, [_c('cb-slide-n-fade', {
    attrs: {
      "isList": true,
      "is-list": true,
      "timeOut": true,
      "reCalculateMargin": true
    }
  }, _vm._l((_vm.giftedSubsDisplayList), function(item, index) {
    return ((!_vm.giftLimit || index < _vm.giftLimit)) ? _c('div', {
      directives: [{
        name: "cb-link",
        rawName: "v-cb-link",
        value: ('shadow'),
        expression: "'shadow'"
      }],
      key: index,
      staticClass: "cb-bar__wrap",
      class: {
        'cb-bar__wrap--noborder': index == _vm.limit - 1 && _vm.giftLimit && _vm.giftedSubsDisplayList.length >= _vm.giftLimit
      },
      attrs: {
        "role": "navigation",
        "data-cb-id": "subscription_details"
      },
      on: {
        "click": function($event) {
          _vm.navigate_to('gift_details', {
            params: {
              giftId: item.giftId
            }
          })
        }
      }
    }, [_c('div', {
      staticClass: "cb-bar__detail",
      class: {
        'cb-bar__detail--alert': item.status == 'unclaimed'
      }
    }, [_c('i', {
      staticClass: "icon-gift",
      style: (_vm.themeColor)
    }), _vm._v(" "), _c('span', {
      staticClass: "cb-bar__middle"
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.getGiftedTxt(item.status, item.receiverName)) + "\n\t\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
      staticClass: "cb-bar__title"
    }, [_c('span', {
      staticClass: "cb-bar__middle"
    }, [_vm._v(_vm._s(item.plan_name))]), _vm._v(" "), (item.plan_quantity > 1) ? _c('span', {
      staticClass: "cb-bar__middle"
    }, [_vm._v(" × " + _vm._s(item.plan_quantity))]) : _vm._e()]), _vm._v(" "), (item.addons && item.addons.length > 0) ? [_c('div', {
      staticClass: "cb-bar__title"
    }, _vm._l((item.addons), function(addon, index) {
      return (index < 1) ? _c('div', {
        key: index,
        staticClass: "cb-bar__title"
      }, [_vm._v("\n\t    \t\t\t\t\t" + _vm._s(addon.details.invoice_name || addon.details.name)), (addon.quantity > 1) ? _c('span', [_vm._v(" × " + _vm._s(addon.quantity))]) : _vm._e()]) : _vm._e()
    }))] : _vm._e(), _vm._v(" "), (item.addons && item.addons.length > 1) ? _c('div', [_vm._v("\n\t\t\t\t\t\t+" + _vm._s(item.addons.length - 1) + " " + _vm._s(_vm.getMoreItemTxt()) + "\n\t        ")]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "cb-bar__content"
    }, [_c('span', {
      staticClass: "cb-bar__price"
    }, [_vm._v("\n\t        \t\t" + _vm._s(_vm._f("cbCurrency")(item.price, item.currency_code)) + "\n\t        \t")])])], 2) : _vm._e()
  }))], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3cd71a52"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/portal/PortalGiftTemplateCommon.vue
// module id = 590
// module chunks = 66